import comp from "./ListModal";
export default comp;
